import { tipoCfeLabel, formatNumeroCfe } from "../utils/formato";

/**
 * Celda "Documento" — identifica el CFE en dos líneas, igual en las 5
 * bandejas.
 *
 * Por qué compuesta y no una columna por campo: la tabla de Contaduría ya
 * tenía 9 columnas y no entraba en pantalla. Mostrar Tipo, Número y RUT como
 * columnas sueltas la llevaría a 11. Plegándolos en una celda de dos líneas
 * se muestra MÁS información ocupando menos ancho, y el RUT (que casi nunca
 * se lee, pero hay que poder verlo) queda en la línea secundaria.
 *
 *   e-Factura  A-0007992
 *   RUT 214789490016
 */
interface Props {
  tipoCfe: number | null;
  serie: string | null;
  nro: string | null;
  rutEmisor: string;
}

export function CfeIdentidad({ tipoCfe, serie, nro, rutEmisor }: Props) {
  return (
    <div className="cfe-identidad">
      <span className="cfe-identidad-principal">
        <span className="cfe-tipo">{tipoCfeLabel(tipoCfe)}</span>
        <span className="mono cfe-numero">{formatNumeroCfe(serie, nro)}</span>
      </span>
      <span className="cfe-identidad-secundaria mono">RUT {rutEmisor}</span>
    </div>
  );
}
